import { getRecipientName } from './getRecipientName';
import { isItemClassMeetingMessage } from '../smimeItemClassUtils';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import Item from 'owa-service/lib/contract/Item';
import Message from 'owa-service/lib/contract/Message';
import SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';

const getEmailAddressString = (recipient: SingleRecipientType): string =>
    (recipient?.Mailbox?.EmailAddress && recipient.Mailbox.EmailAddress.toLowerCase()) || null;

const getSenderName = (emailMessage: Message): string => {
    return emailMessage?.Sender && getRecipientName(emailMessage.Sender.Mailbox);
};

/**
 * Gets From and Sender recipient displayed to user.
 */
const getFromAndSender = (
    item: Item
): { from: string; sender: string; isSenderAddressDifferent: boolean } => {
    const emailMessage = <Message>item;
    const sender = getSenderName(emailMessage) || null;
    if (isItemClassMeetingMessage(item.ItemClass)) {
        // In case of CalendarItem, return the Organizer name
        const calendarItem = <CalendarItem>item;
        const organizer = getRecipientName(calendarItem.Organizer.Mailbox);
        return {
            from: organizer,
            sender: sender || organizer,
            isSenderAddressDifferent:
                !!sender &&
                getEmailAddressString(calendarItem.Organizer) !==
                    getEmailAddressString(emailMessage.Sender),
        };
    }
    return {
        from: emailMessage.From ? getRecipientName(emailMessage.From.Mailbox) : null,
        sender,
        isSenderAddressDifferent:
            getEmailAddressString(emailMessage.From) !== getEmailAddressString(emailMessage.Sender),
    };
};

export default getFromAndSender;
